import { render, staticRenderFns } from "./Member-NameText.vue?vue&type=template&id=237759c8&scoped=true&"
import script from "./Member-NameText.vue?vue&type=script&lang=js&"
export * from "./Member-NameText.vue?vue&type=script&lang=js&"
import style0 from "./Member-NameText.vue?vue&type=style&index=0&id=237759c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237759c8",
  null
  
)

export default component.exports